import type { RedirectType } from 'next/navigation'
import { getLocale } from 'next-intl/server'

import { redirect as intlRedirect } from './navigation'

type IntlRedirectArgs = Parameters<typeof intlRedirect>[0]

export async function redirect(
  href: string | IntlRedirectArgs,
  type?: RedirectType,
): Promise<never> {
  if (typeof href === 'string') {
    return intlRedirect({ href, locale: await getLocale() }, type)
  }

  return intlRedirect(href, type)
}
